import Statistic, { StatisticProps } from './Statistic';
import Countdown from './Countdown';
Statistic.Countdown = Countdown;
export { StatisticProps };
export default Statistic;
